import { render } from "./ProductSalesPerStoreSkeleton.vue?vue&type=template&id=56ad7109&scoped=true"
import script from "./ProductSalesPerStoreSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductSalesPerStoreSkeleton.vue?vue&type=script&lang=js"

import "./ProductSalesPerStoreSkeleton.vue?vue&type=style&index=0&id=56ad7109&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ad7109"]])

export default __exports__